import { useCallback, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import _ from 'lodash';
import { i18n } from '../../../../language';
import { BS_TOOLBAR_STATUS } from '../../../../comm/constant';
import EAdmissionToolbar from '../../components/EADViewFloorPlan/components/EAdmissionToolbar';
import AdmissionLocationViewSetting from '../../components/AdmissionLocationViewSetting';
import {
  buildLocationSettingCubicleParams,
  revampLocationSettingCubicle,
} from '../../components/AdmissionLocationViewSetting/utils';
import { eadmissionAPI } from '../../../../apis';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
  },
  toolbar: {
    position: 'absolute',
    left: '-3.438rem',
  },
}));

export default function SOPDViewSetting() {
  const classes = useStyles();
  const [enableSOPDView, setEnableSOPDView] = useState(false);
  const [cubicleList, setCubicleList] = useState([]);
  const [SOPDVersion, setSOPDVersion] = useState(null);
  const [toolStatus, setToolStatus] = useState({ type: BS_TOOLBAR_STATUS.MOVE, zoom: 1, reset: 0 });
  const [showCreateCubiclePop, setShowCreateCubiclePop] = useState(false);

  const getSOPDCubicles = useCallback(async () => {
    try {
      const { result } = await eadmissionAPI.getSOPDSettingCubicleList();
      setSOPDVersion(result?.version);
      const newCubList = _.map(result?.cubicles, (item) => revampLocationSettingCubicle(item));
      setCubicleList(newCubList);
    } catch (error) {}
  }, []);

  const getSOPDViewSetting = useCallback(async () => {
    try {
      try {
        const { result } = await eadmissionAPI.getSOPDViewVisible();
        setEnableSOPDView(result?.visible === 1);
      } catch (error) {}
    } catch (error) {}
  }, []);

  const updateSOPDViewSetting = useCallback(async (isChecked) => {
    try {
      try {
        const { statusCode } = await eadmissionAPI.updateSOPDViewVisible({ visible: isChecked ? 1 : 0 });
        if (statusCode === '0') {
          getSOPDViewSetting();
        }
      } catch (error) {}
    } catch (error) {}
  }, []);

  const handleReset = async () => {
    await getSOPDCubicles();
    await getSOPDViewSetting();
  };

  const handleUpdate = async (nextCubicleList) => {
    try {
      const params = {
        cubicles: _.map(nextCubicleList, (item) => buildLocationSettingCubicleParams(item)),
        version: SOPDVersion,
      };
      await eadmissionAPI.updateSOPDSettingCubicle(params);
      await getSOPDCubicles();
    } catch (error) {}
  };

  useEffect(() => {
    getSOPDCubicles();
    getSOPDViewSetting();
  }, []);

  return (
    <div className={classes.root}>
      <EAdmissionToolbar
        type="edit"
        status={toolStatus}
        setStatus={setToolStatus}
        handleShowPopup={() => setShowCreateCubiclePop(true)}
        className={classes.toolbar}
      />
      <AdmissionLocationViewSetting
        enableView={enableSOPDView}
        label={i18n.t('EADMISSION_SOPD_LOC_VIEW_SETTING_CONTENT')}
        toolStatus={toolStatus}
        setToolStatus={setToolStatus}
        showCreateCubiclePop={showCreateCubiclePop}
        setShowCreateCubiclePop={setShowCreateCubiclePop}
        cubicleList={cubicleList}
        setCubicleList={setCubicleList}
        updateViewSetting={updateSOPDViewSetting}
        handleReset={handleReset}
        handleUpdate={handleUpdate}
        viewType="SOPD"
      />
    </div>
  );
}
